var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPickDateForProcess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44444 5.4H3.66667V6.6H2.44444V5.4ZM11 2.4V10.8C11 11.46 10.45 12 9.77778 12H1.22222C0.543889 12 0 11.46 0 10.8L0.00611111 2.4C0.00611111 1.74 0.543889 1.2 1.22222 1.2H1.83333V0H3.05556V1.2H7.94444V0H9.16667V1.2H9.77778C10.45 1.2 11 1.74 11 2.4ZM1.22222 3.6H9.77778V2.4H1.22222V3.6ZM9.77778 10.8V4.8H1.22222V10.8H9.77778ZM7.33333 6.6H8.55556V5.4H7.33333V6.6ZM4.88889 6.6H6.11111V5.4H4.88889V6.6Z",
    fill: "#2C2D3E",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickDateForProcess);
export default __webpack_public_path__ + "static/media/pickDateForProcess.34416f5cfb8d136490b8b6f30f3c53ba.svg";
export { ForwardRef as ReactComponent };